type props = {
  width?: number;
  height?: number;
};

export const VelocifiImg: React.FC<props> = ({ width = 200, height = 90 }) => {
  return (
    <>
      <img
        src="/img/velocifi/VELOCIFI (ALL BLACK).png"
        alt="Velocifi"
        width={width}
        height={height}
        className="block dark:hidden"
      />
      <img
        src="/img/velocifi/VELOCIFI (ALL WHITE) (1).png"
        alt="Velocifi"
        width={width}
        height={height}
        className="hidden dark:block"
      />
    </>
  );
};
